import BasePoint from '../BasePoint.js';
import WapiPoint2D from '../WapiPoint2D.js';

export function getFirstPoint(preset) {
  const point = new BasePoint();
  point.latitude = preset.points_domains[0].points[0].location.geometry.coordinates[1];
  point.longitude = preset.points_domains[0].points[0].location.geometry.coordinates[0];

  return point;
}

export function getFirstPoint2(preset) {
  const point = new BasePoint();
  point.latitude = preset.area.points[0].y;
  point.longitude = preset.area.points[0].x;

  return point;
}

export function getPoints(preset) {
  const result = [];

  preset.area.points.forEach(point => {
    const p = new WapiPoint2D();
    p.y = point.y;
    p.x = point.x;
    result.push(point)
  })

  return result;
}